var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49957 7.27453C7.43293 7.27453 8.18957 6.51789 8.18957 5.58453C8.18957 4.65117 7.43293 3.89453 6.49957 3.89453C5.56621 3.89453 4.80957 4.65117 4.80957 5.58453C4.80957 6.51789 5.56621 7.27453 6.49957 7.27453Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96059 4.59879C3.02768 -0.0920414 9.97726 -0.0866246 11.0389 4.60421C11.6618 7.35588 9.95018 9.68504 8.44976 11.1259C7.36101 12.1767 5.63851 12.1767 4.54434 11.1259C3.04934 9.68504 1.33768 7.35046 1.96059 4.59879Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.77aa121a95f4a95d80a4b7aba173e5e3.svg";
export { ForwardRef as ReactComponent };